//React
import { useCallback } from 'react'

//Librerías

//Servicios
import { paginacionContratoLista } from 'actions/CntContratoAction';
//Hooks
import { useLocalization } from 'contexto/localization/useLocalization'


const useListaContratosPaginada = () => {
    const { strings } = useLocalization();

    const obtenerListaContratos = useCallback(async (Search, loadedOptions, { page }, defaultValue) => {
        try {
            const [contratos] = await paginacionContratoLista(page, 30, Search,
                defaultValue);
            if (contratos && contratos.data && contratos.data.data) {
                const lista = [];
                if (page === 1) lista.push({ value: undefined, label: strings.modules.sinContratoRelacionado });
                lista.push(...contratos.data.data.map((c) => ({ value: c.id, label: c.nombre })));
                return {
                    options: lista,
                    hasMore: contratos.data.totalPages >= page,
                    additional: {
                        page: page + 1,
                    },
                };

            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: {
                        page: page + 1,
                    },
                };
            }
        } catch (error) {
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: page + 1,
                },
            };
        }
    }, [strings.modules.sinContratoRelacionado]);

    return {
        obtenerListaContratos,
    };
};

export default useListaContratosPaginada;